module.exports = __webpack_public_path__ + "3d536f380466c415ea74e04b54dcc087.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Regular.svg
// module id = 365
// module chunks = 0